/**
 * Create coupon usages context for custom hook
 */
import { createContext } from 'react'

const CouponUsagesContext = createContext({
  createCouponUsage: () => {},
  fetchCouponUsages: () => {},
})

export default CouponUsagesContext
